import React from 'react';
import { FiLock, FiX } from 'react-icons/fi';
import PricingPlans from '../landing/components/PricingPlans/PricingPlans.jsx';
import '../landing/components/PricingPlans/pricing.css';
import './subscription-paywall.css';

/**
 * Reuses landing PricingPlans for upgrade CTAs (no duplicate pricing layout).
 */
export default function SubscriptionPaywall({
  title = 'Continue with NovaBotX',
  subtitle = 'Your trial has ended. Choose a plan to restore chat and admin access.',
  onClose
}) {
  return (
    <div className="subscription-paywall-backdrop" role="dialog" aria-modal="true" aria-labelledby="paywall-title">
      <div className="subscription-paywall-panel">
        <div className="subscription-paywall-header">
          <span className="subscription-paywall-icon" aria-hidden="true"><FiLock /></span>
          <div className="subscription-paywall-copy">
            <span className="subscription-paywall-kicker">Upgrade</span>
            <h2 id="paywall-title">{title}</h2>
            <p className="subscription-paywall-sub">{subtitle}</p>
          </div>
          {onClose && (
            <button type="button" className="subscription-paywall-x" onClick={onClose} aria-label="Close">
              <FiX aria-hidden="true" />
            </button>
          )}
        </div>
        <div className="subscription-paywall-body">
          <PricingPlans />
        </div>
      </div>
    </div>
  );
}
